import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import pillsData from '../mock/pills.json';

interface PillsState {
  points: number;
  cups: number;
  streak: number;
  isSummaryPointsAwarded: boolean;
  setPills: (data: Partial<Omit<PillsState, 'setPills' | 'resetPills' | 'addPoints' | 'setSummaryPointsAwarded'>>) => void;
  addPoints: (points: number) => void;
  setSummaryPointsAwarded: (awarded: boolean) => void;
  resetPills: () => void;
}

const initialState = {
  points: pillsData.points || 0,
  cups: pillsData.cups || 0,
  streak: pillsData.streak || 0,
  isSummaryPointsAwarded: false,
};

export const usePillsStore = create<PillsState>()(
  persist(
    (set) => ({
      ...initialState,
      
      setPills: (data) => set((state) => ({ ...state, ...data })),

      addPoints: (points) => set((state) => ({ points: state.points + points })),

      setSummaryPointsAwarded: (awarded) => set({ isSummaryPointsAwarded: awarded }),
      
      resetPills: () => set(initialState),
    }),
    {
      name: 'shoonit-pills',
      storage: createJSONStorage(() => localStorage)
    }
  )
);
